import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { AttachmentManagementService } from '../../../services/attachment-management/attachment-management.service';
import { ApplicationFormControlManagerService } from '../../../../../shared/services/application-form-control-manager/application-form-control-manager.service';
import { MatButtonModule } from '@angular/material/button';
import { ApplicationStateService } from '../../../../../shared/services/application-state/application-state.service';

@Component({
    selector: 'app-attachment-required-button',
    templateUrl: './attachment-required-button.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatButtonModule],
})
export class AttachmentRequiredButtonComponent {
    /**
     * Text label displayed on the attachment required button.
     * Can be overridden by parent components to customize the button caption.
     */
    @Input() buttonText: string = 'Attachment Required';

    constructor(
        private readonly attachmentManagementService: AttachmentManagementService,
        private readonly applicationFormControlManagerService: ApplicationFormControlManagerService,
        private readonly applicationStateService: ApplicationStateService,
    ) {}

    /**
     * Handles the click event on the attachment required button.
     * It will open the attachment management dialog for the current application.
     */
    onClick(): void {
        const applicationState =
            this.applicationStateService.getCurrentApplicationState();
        if (applicationState == null) {
            throw new Error(
                'Application state is null. Cannot open attachment management dialog.',
            );
        }

        const applicationId = applicationState.applicationId;
        if (applicationId == null) {
            throw new Error(
                'Application ID is null. Cannot open attachment management dialog.',
            );
        }

        this.attachmentManagementService.displayAttachmentManagementDialog(
            applicationId.toString(),
        );
    }

    /**
     * Determines if the button should be disabled based on the application's read-only state.
     *
     * @returns A boolean indicating if the button is disabled.
     */
    isDisabled(): boolean {
        return this.applicationFormControlManagerService.isReadOnly();
    }
}
